import { useQuery } from "react-query";
import { getJSON } from "../api/http";
import { endpoints } from "../api/endpoints";


interface IParentalControlSettings {
    access: string;
    workhour_type: string;
    workhour_start: string;
    workhour_end: string;
    
}

export const STATUS = {
    ON: 'włączony',
    OFF: 'wyłączony'
}

export const restructureParentalControlData = ({
    access,
    workhour_type,
    workhour_start,
    workhour_end,
}: IParentalControlSettings) => ({
    status: access === '1' ? STATUS.ON : STATUS.OFF,
    // type: workhour_type === '1' ? STATUS.ON : STATUS.OFF,
    type: workhour_type,
    start: workhour_start,
    end: workhour_end,
});

const getParentalControlSettings = async (id: string) => getJSON(endpoints.user.parentalControl + '/' + id);

export interface IParentalControlData {
    id: string,
    successCallback?: Function
}

export const useParentalControlData = ({id, successCallback} : IParentalControlData) => {
    const { data, refetch, isLoading, error } = useQuery("parentalControlSettings" + id, () => getParentalControlSettings(id!), {
            staleTime: Infinity,
        });

    return {
        isLoading,
        data: restructureParentalControlData(data?.data || {}),
        error,
        refetch,
    };
};
